/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpContextToken } from '@angular/common/http';

import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { CompanyService } from '../services/company/company.service';
import { Company } from '../models/company.model';
import { environment } from '../../environments/environment';
import { AUTH_SESSION_REQUEST } from '../services/auth/auth-http.context';

export const SKIP_AUTH_TOKEN = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {
    company?: Company | null;

    constructor(
        private authService: AuthService,
        private companyService: CompanyService
    ) {
        this.companyService.activeCompany$.subscribe((company) => {
            this.company = company;
        });
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.method === 'JSONP') {
            return next.handle(req);
        }
        const session = req.context.get(AUTH_SESSION_REQUEST);
        if (session) {
            let headers = req.headers.delete('Authorization').delete('X-Company-ID');
            if (session.token) headers = headers.set('Authorization', `Bearer ${session.token}`);
            if (session.companyId) headers = headers.set('X-Company-ID', session.companyId);
            return next.handle(req.clone({ headers }));
        }
        // add header for authorization

        let headers = req.headers;
        if (this.company) {
            const envHeaders: any = environment.headers;
            if (envHeaders && envHeaders['X-Company-ID']) {
                headers = req.headers.set('X-Company-ID', envHeaders['X-Company-ID']);
            } else {
                headers = req.headers.set('X-Company-ID', this.company.id.toString());
            }
        }
        if (!req.context.get(SKIP_AUTH_TOKEN)) {
            req = req.clone({
                headers: headers.set('Authorization', this.authService.getAuthorizationHeaders().Authorization),
            });
        }
        return next.handle(req);
    }
}
